export interface ManagementTemplatesState {
  managementTemplates: any[];
  managementTemplatesItem?: ManagementTemplatesItem;
  managementTemplatesStatus: number[];
}

export interface ManagementTemplatesFilter {
  mn_service_id?: number;
  tmpl?: string;
  service_provider_name?: string;
  status_id?: number;
}

export interface ManagementTemplatesItem {
  id?: number;
  service_provider_name?: string;
  mn_service_id?: number;
  mn_service_name?: string;
  tmpl?: string;
  status_id: number;
  description?: string;
}

export class ManagementTemplatesItemImpl implements ManagementTemplatesItem {
  service_provider_name?: string;
  mn_service_id?: number;
  mn_service_name?: string;
  tmpl?: string;
  status_id: number;
  description?: string;
  constructor() {
    this.status_id = 0;
  }
}

